import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSwipeable } from 'react-swipeable'
import { navigate } from "gatsby";
import { useTheme } from '~/contexts/ThemeContext'
import { useCart } from '~/contexts/CartContext'
import useAnalytics from '~/utils/analytics'
import { imgSize, notBlank, jnstyls } from '~/utils/helpers'

import { IconChevLeft, IconChevRight } from '~/components/icons/chevrons'

import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/panels/cart-upsell.module.scss"


const TestCartUpsell = ({ prodId, recProds, groupTitle='People Also Bought', type='both' }) => {
  const { setFreeze, isTouches, analytics, setAnalytics, quick } = useTheme()
  const { setCartOpen } = useCart()
  const { elev_select, ga_tile_click } = useAnalytics()
  
  const { recs, outfits } = recProds
  const [items, setItems] = useState([])  
  const [pos, setPos] = useState(0)
  const [backon, setBackon] = useState(false)
  const [forwon, setForwon] = useState(true)

  const total = recProds.recs?.length || 0

  const wrapRef = useRef(null)
  const slideRef = useRef(null)

  const handleBack = () => {
    const inview = arrow_inview()
    let new_pos = inview[0] - 1 - inview.length
    if (new_pos < 0) new_pos = 0

    setPos(new_pos)
  }

  const handleForward = () => {
    const inview = arrow_inview()
    let new_pos 
    if (inview.length) {
      new_pos = inview[inview.length - 1] + 1
      if (new_pos + inview.length >= total) new_pos = total
      if (pos === total) new_pos = 0
    } else {
      new_pos = total
    }
    if (!slideRef.current) {
      const arr = Array.from(document.querySelectorAll(`[crec="${prodId}"]`))
      slideRef.current = arr[new_pos - 1]
    }

    setPos(new_pos)
  }

  const arrow_inview = () => {
    const wrap = wrapRef.current
    const wrap_rect = wrap.getBoundingClientRect()
    const arr = Array.from(document.querySelectorAll(`[crec="${prodId}"]`))

    let inview = []
    arr.forEach((x, index) => {
      const el = x.getBoundingClientRect()
      const el_left = el.left - wrap_rect.left 
      const el_right = el.left + el.width - wrap_rect.left - 20
      if (el_left >= 0 && el_right < wrap_rect.width) inview.push(index)
    })
    return inview
  }

  const deskChange = useCallback(() => {
    const arr = Array.from(document.querySelectorAll(`[crec="${prodId}"]`))
    if (arr.length < 1) return
    const wrap = wrapRef.current
    const wrap_rect = wrap.getBoundingClientRect()
    const curr_scroll = wrap.scrollLeft

    const next_ind = pos === arr.length ? arr.length - 1 : pos
    const next = arr[next_ind].getBoundingClientRect()
    const next_scroll = next.left + (curr_scroll - wrap_rect.left) - 10

    wrap.scrollTo({
      top: 0,
      left: next_scroll,
      behavior: 'smooth'
    });
  }, [pos])

  const checkScroll = () => {
    const wrap = wrapRef.current
    const max_scrll = Math.round(wrap.scrollWidth - wrap.getBoundingClientRect().width) - 1
    
    const new_back = wrap.scrollLeft >= 5
    if (new_back !== backon) setBackon(new_back)

    const new_forw = wrap.scrollLeft <= max_scrll
    if (new_forw !== forwon) setForwon(new_forw)
  }

  const handleLink = (product, tile_ind) => {
    window._conv_q = window._conv_q || []
    window._conv_q.push(["triggerConversion", "100494059"])
    
    setFreeze(false)
    setCartOpen(false)
    setAnalytics({...analytics, list: 'cart recommendation'})
    navigate(`/products/${product.handle}`)
    ga_tile_click(product, tile_ind, 'cart recommendation')
    elev_select(product, tile_ind, 'cart recommendation')
  }

  const pick_img = (item) => {
    let image = item.image
    if (!image && item.media && item.media.find(x => x.type === 'IMAGE')) {
      image = item.media.find(x => x.flat) ? item.media.find(x => x.flat) : item.media.find(x => x.type === 'IMAGE')
      image = image.src
    }

    return imgSize(image,500)
  }
  
  useEffect(() => {
    deskChange()
    
  }, [pos, slideRef, deskChange])

  useEffect(() => {
    setItems(recProds.recs || [])
    
  }, [recProds])

  // useEffect(() => {
  //   const el = wrapRef.current

  //   if ( el ) {
  //     el.addEventListener('scroll', checkScroll, { passive: true })
  //     return () => {
  //       el.removeEventListener('scroll', checkScroll)
  //     }
  //   }
  // })

  return (
    <div className={jnstyls([styles.upsell, styles.item_upsell])} c-ups=''>
      <div className={styles.recs_head}>
        <div className={styles.title}>
          {groupTitle}
        </div>
        {/*<div className={styles.rec_mores}>
          <button 
            type="button"
            className={`${aria_btn} ${styles.rec_more} ${backon ? '' : styles.off}`}
            disabled={backon ? undefined : 'disabled'}
            onClick={(e)=>{handleBack()}}
            aria-label='Previous recommendations'
          >
            <IconChevLeft icon_classes="" />
          </button>
          <button 
            type="button"
            className={`${aria_btn} ${styles.rec_more} ${forwon ? '' : styles.off}`}
            disabled={forwon ? undefined : 'disabled'}
            onClick={(e)=>{handleForward()}}
            aria-label='Next recommendations'
          >
            <IconChevRight icon_classes="" />
          </button>
        </div>*/}
      </div>

      {/*<div className={styles.recswr} ref={wrapRef}>
      </div>*/}
      <div className={styles.recs}>
        {items.length > 0 && items.map( (item, index) => 
          <button 
            type="button"
            key={item.handle} 
            className={[aria_btn, styles.rec].join(' ')}
            onClick={(e)=>{handleLink(item, index)}}
            ref={pos === index ? slideRef : undefined}
            crec={prodId}
          >
            <div className={styles.rec_image}>
              <img 
                className={styles.img} 
                src={pick_img(item)}
                alt={`Buck Mason ${item.title}`} 
                height="300" 
                width="200" 
              />
            </div>
            <div className={styles.rec_content}>
              {(notBlank(item.clr) && notBlank(item.product_line?.name)) ? (
                <>
                  <div className={styles.title_price}>
                    <div className={styles.title}>
                      {item.product_line.name}
                    </div>
                    <div className={styles.price}>
                      ${item.first_product_price}
                    </div>
                  </div>
                  <div className={styles.color}>
                    {item.clr}
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.title}>
                    {(notBlank(item.product_line?.name) && notBlank(item.color)) ? item.product_line.name : item.title}
                  </div>
                  {notBlank(item.color) && (
                    <div className={styles.color}>
                      {item.color}
                    </div>
                  )}
                  <div className={styles.price}>
                    ${item.first_product_price}
                  </div>
                </>
              )}
            </div>
          </button>
        )}
      </div>
    </div>

  )
}


export default TestCartUpsell



